import { createStyles, makeStyles, Theme } from '@material-ui/core';

export interface ReportsPageStylesProps {
    
}
export const useStyles = makeStyles<Theme, ReportsPageStylesProps>((theme: Theme) =>
  createStyles({
    breadcrumbsContainer: {
      marginBottom: "40px",
      width: "95%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
  }),
);